import React from 'react';

/**
 * Small status pill used to clearly distinguish live features from upcoming ones.
 *
 * @param {'live'|'soon'} variant
 */
export default function Badge({ variant = 'live', children }) {
  const styles =
    variant === 'soon'
      ? 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200'
      : 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-200';

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-3 py-1 text-xs font-semibold ${styles}`}
    >
      {variant === 'live' && (
        <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" aria-hidden="true" />
      )}
      {children}
    </span>
  );
}
